import { render, staticRenderFns } from "./Feeds.vue?vue&type=template&id=81b61f3e&"
import script from "./Feeds.vue?vue&type=script&lang=js&"
export * from "./Feeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports